/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tXkSR39sgCDWSitZxC5xFV
// Component: JJhv0MV9DH

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  PlasmicIcon as PlasmicIcon__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import IconButton from "../../components/widgets/IconButton"; // plasmic-import: LPry-TF4j22a/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "../PP__plasmickit_design_system.module.css"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/projectcss
import sty from "./PlasmicExpandButton.module.css"; // plasmic-import: JJhv0MV9DH/css

import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon
import ChevronLeftSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronLeftSvg"; // plasmic-import: 0-_N6JM-u/icon
import ChevronRightSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronRightSvg"; // plasmic-import: HBGx-zeiX/icon

createPlasmicElementProxy;

export type PlasmicExpandButton__VariantMembers = {
  right: "right";
  isExpanded: "isExpanded";
  size: "small";
};
export type PlasmicExpandButton__VariantsArgs = {
  right?: SingleBooleanChoiceArg<"right">;
  isExpanded?: SingleBooleanChoiceArg<"isExpanded">;
  size?: SingleChoiceArg<"small">;
};
type VariantPropType = keyof PlasmicExpandButton__VariantsArgs;
export const PlasmicExpandButton__VariantProps = new Array<VariantPropType>(
  "right",
  "isExpanded",
  "size"
);

export type PlasmicExpandButton__ArgsType = {};
type ArgPropType = keyof PlasmicExpandButton__ArgsType;
export const PlasmicExpandButton__ArgProps = new Array<ArgPropType>();

export type PlasmicExpandButton__OverridesType = {
  root?: Flex__<typeof IconButton>;
};

export interface DefaultExpandButtonProps {
  right?: SingleBooleanChoiceArg<"right">;
  isExpanded?: SingleBooleanChoiceArg<"isExpanded">;
  size?: SingleChoiceArg<"small">;
  className?: string;
}

const $$ = {};

function PlasmicExpandButton__RenderFunc(props: {
  variants: PlasmicExpandButton__VariantsArgs;
  args: PlasmicExpandButton__ArgsType;
  overrides: PlasmicExpandButton__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "right",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.right,
      },
      {
        path: "isExpanded",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isExpanded,
      },
      {
        path: "size",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.size,
      },
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <IconButton
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      children2={
        <ChevronDownSvgIcon
          className={classNames(projectcss.all, sty.svg__wgw3N)}
          role={"img"}
        />
      }
      className={classNames("__wab_instance", sty.root, {
        [sty.rootisExpanded]: hasVariant($state, "isExpanded", "isExpanded"),
        [sty.rootsize_small]: hasVariant($state, "size", "small"),
      })}
      isActive={
        hasVariant($state, "isExpanded", "isExpanded") ? true : undefined
      }
      size={hasVariant($state, "size", "small") ? "small" : undefined}
      type={["roundClear"]}
    >
      <PlasmicIcon__
        PlasmicIconType={
          hasVariant($state, "isExpanded", "isExpanded")
            ? ChevronDownSvgIcon
            : hasVariant($state, "right", "right")
            ? ChevronRightSvgIcon
            : ChevronLeftSvgIcon
        }
        className={classNames(projectcss.all, sty.svg__y7QMe, {
          [sty.svgisExpanded__y7QMe5Dg9P]: hasVariant(
            $state,
            "isExpanded",
            "isExpanded"
          ),
          [sty.svgisExpanded_right__y7QMe5Dg9PJego8]:
            hasVariant($state, "right", "right") &&
            hasVariant($state, "isExpanded", "isExpanded"),
          [sty.svgright__y7QMejego8]: hasVariant($state, "right", "right"),
          [sty.svgsize_small__y7QMeyBaWa]: hasVariant($state, "size", "small"),
        })}
        role={"img"}
      />
    </IconButton>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: typeof IconButton;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicExpandButton__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicExpandButton__VariantsArgs;
    args?: PlasmicExpandButton__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicExpandButton__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicExpandButton__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicExpandButton__ArgProps,
          internalVariantPropNames: PlasmicExpandButton__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicExpandButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicExpandButton";
  } else {
    func.displayName = `PlasmicExpandButton.${nodeName}`;
  }
  return func;
}

export const PlasmicExpandButton = Object.assign(
  // Top-level PlasmicExpandButton renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicExpandButton
    internalVariantProps: PlasmicExpandButton__VariantProps,
    internalArgProps: PlasmicExpandButton__ArgProps,
  }
);

export default PlasmicExpandButton;
/* prettier-ignore-end */
